// extracted by mini-css-extract-plugin
export default {"borderBlock":"DashedDescriptorsBlock_borderBlock__ujAtP"};